
// Wiggle Card Animation
// // Add this script to your page
// document.addEventListener('DOMContentLoaded', function() {
//   const imageBlock = document.querySelector('.image-block--Ad1k4aGV2SUpuYlI2T__image_btGqbx');
  
//   if (imageBlock) {
//     const img = imageBlock.querySelector('img');
    
//     // Create observer
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           img.classList.add('shuffle-animation');
//           // Optional: disconnect after first animation
//           // observer.disconnect();
//         }
//       });
//     }, {
//       threshold: 0.2 // Trigger when 20% of element is visible
//     });
    
//     observer.observe(imageBlock);
//   }
// });

// Flip animation
document.addEventListener('DOMContentLoaded', function() {
    const selectorName = [
        '.image-block--Ad1k4aGV2SUpuYlI2T__image_btGqbx',
        ".image-block--AS0UyMGZUZTc2dkpaU__image_brbRWf",
        ".image-block--ARTZvVnhLVlZHbXJoN__image_DNLmGN",
        ".image-block--AdE91UVJLRmthZjdSU__image_RXFjjf",
        ".image-block--AbWlxcktselV0TEpSM__image_WdPaxF",
        ".image-block--ANHY5SENvNzluNFp1W__image_dwW3gr",
        '.image-block--AaWhoWWFyZ0hKTnE1N__image_YGy7Bc',
        ".image-block--ANVlJdmV3UVVFY055U__image_tdnzne",
        ".image-block--AQVk5VlZjKzNwOXFmK__image_VQwzrp",
        ".image-block--AR1g2L0tiSFpjNEw3W__image_bq8GnK"
    ];

    const backImageUrl = 'https://cdn.shopify.com/s/files/1/0670/8763/0549/files/card_back.webp?v=1763654944';

    selectorName.forEach((selector, index) => {
        const imageBlock = document.querySelector(selector);

        if (imageBlock) {
            const img = imageBlock.querySelector('img');
            const frontImageUrl = img.src;
            
            const computedStyle = window.getComputedStyle(img);
            
            const flipContainer = document.createElement('div');
            flipContainer.className = 'flip-container';
            
            flipContainer.style.width = computedStyle.width;
            flipContainer.style.height = computedStyle.height;
            flipContainer.style.display = computedStyle.display;
            flipContainer.style.position = computedStyle.position;
            flipContainer.style.borderRadius = computedStyle.borderRadius;
            
            const flipCard = document.createElement('div');
            flipCard.className = 'flip-card';
            
            const frontSide = document.createElement('div');
            frontSide.className = 'flip-front';
            
            const backSide = document.createElement('div');
            backSide.className = 'flip-back';
            
            // Start with ORIGINAL image on front (will flip to show white panel)
            const frontImg = img.cloneNode(true);
            frontImg.style.width = '100%';
            frontImg.style.height = '100%';
            frontSide.appendChild(frontImg);
            
            // White panel on back (will be shown after initial flip)
            const backImg = document.createElement('img');
            backImg.src = backImageUrl;
            backImg.style.width = '100%';
            backImg.style.height = '100%';
            backImg.style.objectFit = computedStyle.objectFit || 'cover';
            backImg.className = img.className;
            backSide.appendChild(backImg);
            
            flipCard.appendChild(frontSide);
            flipCard.appendChild(backSide);
            flipContainer.appendChild(flipCard);
            
            img.parentNode.insertBefore(flipContainer, img);
            img.style.display = 'none';
            
            // Auto-flip on page load with staggered timing
            setTimeout(() => {
                flipCard.classList.add('flipped');
            }, 200 + (index * 150)); // Stagger the auto-flip for each card
            
            // Add click event for manual flipping
            flipContainer.style.cursor = 'pointer';
            flipContainer.addEventListener('click', function() {
                flipCard.classList.toggle('flipped');
            });
        }
    });
});

// Target specific section IDs
document.addEventListener('DOMContentLoaded', function() {
    const sectionIds = [
        'shopify-section-template--20388451909845__section_Qxgpxq',
        'shopify-section-template--20388451909845__section_CJTnFb',
        'shopify-section-template--20388451909845__section_LtWJJ7',
        'shopify-section-template--20388451909845__section_QgXVDp',
        'shopify-section-template--20388451909845__section_TCnMd7',
        'shopify-section-template--20388451909845__section_akkdNJ',
        'shopify-section-template--20388451909845__section_Xb73Cp',
        'shopify-section-template--20388451909845__section_389WFU',
        'shopify-section-template--20388451909845__section_kRbc3t',
        'shopify-section-template--20388451909845__section_MMcchX'
    ];
    
    const animationTypes = ['fade-left', 'fade-right', 'zoom-in', 'fade-down', 'fade-up'];
    
    function shuffleArray(array) {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    }
    
    const sections = sectionIds
        .map(id => document.getElementById(id))
        .filter(el => el !== null);
    
    const shuffledAnimations = shuffleArray(animationTypes);
    
    // Use requestAnimationFrame for smoother initial setup
    requestAnimationFrame(() => {
        sections.forEach((section, index) => {
            section.classList.add('scroll-reveal');
            const animationType = shuffledAnimations[index % shuffledAnimations.length];
            section.classList.add(animationType);
            
            // Force hardware acceleration
            section.style.willChange = 'transform, opacity';
        });
    });
    
    // Optimized observer options
    const observerOptions = {
        root: null,
        rootMargin: '50px', // Start animation before fully visible
        threshold: 0.1 // Reduced threshold
    };
    
    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Use requestAnimationFrame for smooth animation trigger
                requestAnimationFrame(() => {
                    entry.target.classList.add('revealed');
                    
                    // Clean up will-change after animation completes
                    setTimeout(() => {
                        entry.target.style.willChange = 'auto';
                    }, 800); // Match your animation duration
                });
                
                observer.unobserve(entry.target);
            }
        });
    };
    
    const observer = new IntersectionObserver(observerCallback, observerOptions);
    
    sections.forEach(section => {
        observer.observe(section);
    });
});